import './style.css';
import App from './App';
import TouchClickPolyfill from './utils/TouchClickPolyfill';

new TouchClickPolyfill();

new App();
